export default __webpack_public_path__ + "static/stacked-bar-aeacca6b7e42d9c7cf81beee6cd0e330.png";